module.exports = __webpack_public_path__ + "static/media/screen4.2dc10f78.png";